import { config } from './config';

export async function fetchNewQuestion(allQuestions, productLink, clickedQuestionId, questionsClicked, sessionId, customerId, website, productNumber, userId) {
    try {
        const allQuestionIds = allQuestions.map(q => q.id);
        const clickOrder = questionsClicked.length;
        const userAgent = navigator.userAgent;
        const body = {
            aq: allQuestionIds,
            co: clickOrder,
            url: productLink,
            ua: userAgent,
            site: website,
            c_id: customerId,
            se_id: sessionId,
            q_id: clickedQuestionId,
            u_id: userId,
            p_n: productNumber ? productNumber : null,
        }
    
        const response = await fetch(`${config.BASE_URL}/chat/proceed`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data; 
    } catch (error) {
        console.error('Error fetching new question:', error);
        throw error;
    }
}